"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var AudioManager_1 = require("../AudioManager");
var ConnectionManager_1 = require("../ConnectionManager");
var GameConstants_1 = require("../GameConstants");
var GameVars_1 = require("../GameVars");
var BoardManager_1 = require("./BoardManager");
var GUI = /** @class */ (function (_super) {
    __extends(GUI, _super);
    function GUI(game) {
        var _this = _super.call(this, game, null, "gui") || this;
        _this.autoCompleteButton = new Phaser.Button(_this.game, GameConstants_1.GameConstants.GAME_WIDTH / 2, GameConstants_1.GameConstants.GAME_HEIGHT - 100, "texture_atlas_1", _this.onClickAutoComplete, _this);
        _this.autoCompleteButton.setFrames("btn_autocomplete", "btn_autocomplete", "btn_autocomplete");
        _this.autoCompleteButton.anchor.set(.5, 1);
        _this.autoCompleteButton.scale.y = GameVars_1.GameVars.scaleY;
        _this.autoCompleteButton.visible = false;
        _this.add(_this.autoCompleteButton);
        _this.menuButton = new Phaser.Button(_this.game, 10, 10, "texture_atlas_1", _this.onClickMenu, _this);
        _this.menuButton.setFrames("btn_menu", "btn_menu", "btn_menu");
        _this.menuButton.anchor.set(0);
        _this.menuButton.scale.y = GameVars_1.GameVars.scaleY;
        _this.menuButton.input.pixelPerfectOver = true;
        _this.menuButton.forceOut = true;
        if (ConnectionManager_1.ConnectionManager.isBattle) {
            _this.menuButton.visible = false;
        }
        _this.add(_this.menuButton);
        _this.soundButton = new Phaser.Button(_this.game, GameConstants_1.GameConstants.GAME_WIDTH - 10, 10, "texture_atlas_1", _this.onClickSound, _this);
        if (GameVars_1.GameVars.sound) {
            _this.soundButton.setFrames("btn_sound_on", "btn_sound_on", "btn_sound_on");
        }
        else {
            _this.soundButton.setFrames("btn_sound_off", "btn_sound_off", "btn_sound_off");
        }
        _this.soundButton.anchor.set(1, 0);
        _this.soundButton.scale.y = GameVars_1.GameVars.scaleY;
        _this.soundButton.input.pixelPerfectOver = true;
        _this.soundButton.forceOut = true;
        _this.add(_this.soundButton);
        return _this;
    }
    GUI.prototype.onClickAutoComplete = function () {
        this.autoCompleteButton.visible = false;
        BoardManager_1.BoardManager.currentInstance.autoCompleteGame();
    };
    GUI.prototype.showAutoComplete = function () {
        this.autoCompleteButton.visible = false;
    };
    GUI.prototype.onClickMenu = function () {
        BoardManager_1.BoardManager.currentInstance.showMenuLayer();
        GameVars_1.GameVars.paused = true;
        gamezop.isGamePaused = true;
    };
    GUI.prototype.onClickSound = function () {
        if (GameVars_1.GameVars.sound) {
            GameVars_1.GameVars.sound = false;
            this.soundButton.setFrames("btn_sound_off", "btn_sound_off", "btn_sound_off");
        }
        else {
            GameVars_1.GameVars.sound = true;
            this.soundButton.setFrames("btn_sound_on", "btn_sound_on", "btn_sound_on");
        }
        if (!GameVars_1.GameVars.sound) {
            AudioManager_1.AudioManager.getInstance().isSoundMuted = true;
            AudioManager_1.AudioManager.getInstance().mute();
            oMetaManager.localSetItem("isMuted", true);
        }
        else {
            AudioManager_1.AudioManager.getInstance().isSoundMuted = false;
            AudioManager_1.AudioManager.getInstance().unmute();
            oMetaManager.localSetItem("isMuted", false);
        }
        oMetaManager.localSetItem(GameConstants_1.GameConstants.AUDIO_STATE_KEY, JSON.stringify(GameVars_1.GameVars.sound));
        AudioManager_1.AudioManager.getInstance().playSound("btn_press");
    };
    return GUI;
}(Phaser.Group));
exports.GUI = GUI;
